import React from "react";
import {Typography} from "antd";

const CandidateStatus = {
    StatusUninvited:  'Not Invited',
    StatusPendingInvite:  'Notified.  No Response Yet',
    StatusApproved:  'Interested!',
    StatusRejected:  'Not Interested',
    StatusWithdrawn:  'Withdrew Interest',
    StatusScopeOutlined: 'Has Outlined Scope',
    StatusQuoteConfirmed: 'Has Confirmed Quote',
}

const IsCandidate = WrappedClass => {
    return class IsCandidate extends WrappedClass {
        static CandidateStatus = CandidateStatus;
        /*
        |--------------------------------------------------------------------------
        | Candidate Helper
        |--------------------------------------------------------------------------
        */

        isFixedFee() {
            return this.job_candidate?.is_fixed_fee_contract
        }

        isFixedRetainer() {
            return this.job_candidate?.is_fixed_retainer_contract
        }

        isTimeMaterials() {
            return !this.isFixedFee() && !this.isFixedRetainer()
        }

        hasCandidateStatus()
        {
            return TB.isDefined(this.job_candidate?.status);
        }

        candidateStatus()
        {
            let statuses = TB.invert(laravel.job_candidate_statuses);
            if (this.job_candidate && this.job_candidate.status && statuses[this.job_candidate.status]) {
                return parseInt(statuses[this.job_candidate.status]);
            }

            return false;
        }

        matchStatus()
        {
            let statuses = TB.invert(laravel.job_candidate_statuses);
            if (this.job_candidate && this.job_candidate.client_match_status
                && statuses[this.job_candidate.client_match_status]) {
                return parseInt(statuses[this.job_candidate.client_match_status]);
            }

            return false;
        }

        matchStatusName()
        {
            return laravel.job_candidate_statuses[this.matchStatus()];
        }

        candidateStatusName()
        {
            return laravel.job_candidate_statuses[this.candidateStatus()];
        }

        statusImage() {
            if (this.shortlistedAccepted()) {
                return '/images/profile-banners/shortlisted-banner.png'
            }
            if(this.declinedPosition()) {
                return '/images/profile-banners/declined-banner.png'
            }
            if (this.matchStatusIsInterested()) {
                return '/images/profile-banners/interested-banner.png'
            }
            return false;
        }
        statusLabel() {
            if (this.shortlistedAccepted()) {
                return 'Accepted'
            }
            if(this.declinedPosition()) {
                return 'Declined'
            }
            if (this.matchStatusIsInterested()) {
                return 'Interested'
            }
            return false;
        }

        hasBeenInvited() {
            return this.job_candidate?.talent_invited_at
                && (this.job_candidate?.is_shortlisted || this.matchStatusIsRejected());
        }

        matchStatusIsInterested() {
            if (this.isFixedFee() && !this.hasConfirmedScope()) {
                return false;
            }
            return this.matchStatusName() === CandidateStatus.StatusApproved
        }
        matchStatusIsUnknown() {
            return !this.matchStatus()
        }
        matchStatusIsRejected() {
            return this.matchStatusName() === CandidateStatus.StatusWithdrawn || this.matchStatusName() === CandidateStatus.StatusRejected
        }

        statusIsPending() {
            if (this.statusIsRejected() || this.statusIsWithdrawn()) {
                return false;
            }
            if (this.isFixedFee() && !this.hasConfirmedPayout() && this.hasBeenInvited()) {
                return true;
            }
            if (!this.isFixedFee() && !this.matchStatusIsInterested() && this.hasBeenInvited()) {
                return true;
            }

            return this.hasBeenInvited() && this.candidateStatusName() === CandidateStatus.StatusPendingInvite
        }

        statusIsOutlinedScope() {
            return this.candidateStatusName() === CandidateStatus.StatusScopeOutlined
        }

        statusIsQuoteConfirmed() {
            return this.candidateStatusName() === CandidateStatus.StatusQuoteConfirmed
        }
        statusIsApproved() {
            return this.candidateStatusName() === CandidateStatus.StatusApproved
        }

        statusIsRejected() {
            return this.candidateStatusName() === CandidateStatus.StatusRejected
        }

        statusIsWithdrawn() {
            return this.candidateStatusName() === CandidateStatus.StatusWithdrawn
        }

        disabledFromInvite() {
            return this.declinedPosition() || this.job_candidate?.was_disliked || this.isShortlisted()
        }

        declinedPosition() {
            return this.statusIsRejected() || this.statusIsWithdrawn()
        }

        isAssigned() {
            return this.job_candidate?.is_assigned
        }

        isShortlisted() {
            return this.job_candidate?.is_shortlisted
        }

        wasLiked() {
            return this.job_candidate?.was_liked
        }
        wasDisliked() {
            return this.job_candidate?.was_disliked
        }

        coverLetter() {
            return this.job_candidate?.cover_letter
        }
        relevantExperience() {
            return this.job_candidate?.relevant_experience
        }

        shortlistedAccepted() {
            return !this.isAssigned() && !this.declinedPosition() && this.isShortlisted() && this.hasProposalForClient();
        }

        isPendingShortlisted() {
            return !this.isAssigned() && !this.declinedPosition() && this.statusIsPending();
        }

        /*
        |--------------------------------------------------------------------------
        | Candidate Matching
        |--------------------------------------------------------------------------
        */
        hasMatching() {
            return !!this.matching
        }
        overallMatchPercent(round) {
            if (round) {
                return Math.round(this.matching?.overall?.percent)
            }
            return this.matching?.overall?.percent
        }

        // matchScoresForCriteria(criteria = {}) {
        //
        //
        //     console.log('matchScoresForCriteria', {metrics: this.metrics,criteria});
        //
        //
        //     let matchScores = this.metrics;
        //     if (matchScores.industries_brands_match) {
        //         matchScores.industries_brands_match.total_max_count = (matchScores.industries_brands_match.brands_max_count || 0) +
        //             (matchScores.industries_brands_match.industries_max_count || 0)
        //         matchScores.industries_brands_match.total_count = (matchScores.industries_brands_match.brands_count || 0) +
        //             (matchScores.industries_brands_match.industries_count || 0)
        //     }
        //
        //     const seniorExp = criteria.wants_senior_experience || criteria.experience?.senior;
        //     const intermediateExp = criteria.wants_intermediate_experience || criteria.experience?.intermediate;
        //     const juniorExp = criteria.wants_junior_experience || criteria.experience?.junior;
        //
        //     const hasExperienceCriteria = seniorExp || intermediateExp || juniorExp;
        //
        //     let criteriaByImportance = TB.cloneDeep(criteria);
        //     for (let criteriaType of ['industries', 'skills']) {
        //         if (criteria[criteriaType]?.length) {
        //             for(let[level, importanceLabel] of Object.entries(laravel.importance_levels)) {
        //                 criteriaByImportance[`${TB.snakeCase(importanceLabel)}_${criteriaType}`] = TB.filter(criteria[criteriaType], ['importance', parseInt(level)]);
        //                     // console.log(`matchScoresForCriteria${importanceLabel}`, criteria[criteriaType],parseInt(level),)
        //             }
        //         }
        //     }
        //     const mapCriteriaForImportance = (criteriaType, importance = 'nice_to_have', profiledItems) => {
        //
        //         importance = TB.snakeCase(importance)
        //
        //         let criteriaImportance = `${importance}_${criteriaType}`;
        //
        //         console.log('mapCriteriaForImportance', criteriaByImportance[criteriaImportance])
        //
        //         if (!profiledItems.length &&
        //             TB.isArray(criteriaByImportance[criteriaImportance]) &&
        //             !criteriaByImportance[criteriaImportance].length) return false;
        //
        //         profiledItems = TB.keyBy([...profiledItems], 'id');
        //
        //         if (TB.isArray(criteriaByImportance[criteriaImportance]) && criteriaByImportance[criteriaImportance].length) {
        //
        //             let matched = [];
        //             let unmatched = [];
        //
        //             for (let item of criteriaByImportance[criteriaImportance]) {
        //                 if (parseInt(item.id || item.value) && profiledItems[parseInt(item.id || item.value)]) {
        //                     matched.push(profiledItems[parseInt(item.id || item.value)])
        //                 } else {
        //                     unmatched.push(item);
        //                 }
        //             }
        //
        //             // console.log('mapCriteriaForImportance', matched, unmatched)
        //             matched = TB.filter([...matched], match => match);
        //             unmatched = TB.filter([...unmatched], unmatch => unmatch);
        //
        //             return {
        //                 ...(this.matching?.[criteriaType]?.[importance] || {}),
        //                 matched,
        //                 unmatched
        //             }
        //         }
        //         return false;
        //     }
        //     const matchingByProperty = (prop, profileProps = []) => {
        //         if (prop === 'skills' || prop === 'industries') {
        //             let matchScore = {};
        //
        //             let importanceLevels = TB.values(laravel.importance_levels).reverse();
        //
        //             for (let level of importanceLevels) {
        //
        //                 let matchName = TB.snakeCase(level)
        //
        //                 let match = mapCriteriaForImportance(prop, level, profileProps);
        //
        //                 console.log('matchingByProperty', match)
        //                 if (match) {
        //                     matchScore[matchName] = match
        //                 }
        //             }
        //
        //             return matchScore;
        //         }
        //         if (!criteria[prop]?.length) {
        //             return [];
        //         }
        //         let userPropsIds = TB.map(profileProps, 'id')
        //         let items = TB.map(criteria[prop], item => {
        //             let match = userPropsIds?.includes(item.id);
        //             if (match) {
        //                 return {
        //                     ...(TB.find(profileProps, [
        //                         'id',
        //                         parseInt(item.id)
        //                     ])),
        //                     match
        //                 }
        //             }
        //             return {
        //                 ...item,
        //                 match
        //             }
        //         });
        //         items = TB.orderBy(items, 'match', 'desc')
        //
        //         return items
        //
        //     }
        //
        //     const matchingExp = () => {
        //         // console.log('matchingExp', talentCriteria.disciplines);
        //
        //         const expMultiSelectMapping = {
        //             junior: 80,
        //             intermediate: 95,
        //             senior: 100,
        //         }
        //         let matched_scores = [];
        //
        //         if (seniorExp) {
        //             matched_scores.push(expMultiSelectMapping.senior)
        //         }
        //         if (intermediateExp) {
        //             matched_scores.push(expMultiSelectMapping.intermediate)
        //         }
        //         if (juniorExp) {
        //             matched_scores.push(expMultiSelectMapping.junior)
        //         }
        //
        //         let talentExpOptions = laravel.talent_experience_levels;
        //
        //         let disciplines = TB.map(criteria.disciplines || [], discipline => {
        //             let match = TB.find(TB.filter(this.talent_disciplines, dis => dis.is_approved || !TB.isDefined(dis.is_approved)), [
        //                 'id',
        //                 parseInt(discipline.id)
        //             ]);
        //
        //             let meetsCriteria = false;
        //             let selectedScore = false;
        //             let talentScore = false;
        //             if (match && match?.is_approved && match?.talent_score) {
        //                 talentScore = match.talent_score || parseInt(TB.first(TB.keys(talentExpOptions)))
        //
        //                 meetsCriteria =  matched_scores.includes(talentScore);
        //
        //                 selectedScore = talentExpOptions[talentScore];
        //             }
        //             if (!hasExperienceCriteria) {
        //                 meetsCriteria = true;
        //             }
        //             return {
        //                 match: !!match,
        //                 meets_criteria: meetsCriteria,
        //                 total_experience: talentScore,
        //                 total_experience_label: selectedScore ? `${selectedScore.level} (${selectedScore.label})` : (<Typography.Text type="secondary" className="italic">None</Typography.Text>),
        //                 ...discipline
        //             }
        //         })
        //         disciplines = TB.orderBy(disciplines, 'match', 'desc')
        //
        //         if (disciplines.length > 10) {
        //             disciplines = TB.filter(disciplines, ['match', true])
        //         }
        //         return TB.orderBy(disciplines, 'meets_criteria', 'desc')
        //     }
        //
        //     return {
        //         overall_match: matchScores.overall_match,
        //         industries_brands_match: {
        //             ...(matchScores?.industries_brands_match || {}),
        //             industries: matchingByProperty('industries', this.industries_worked || []),
        //             brands: matchingByProperty('brands', this.brands || []),
        //         },
        //         skills_match: {
        //             ...(matchScores?.skills_match || {}),
        //             skills: matchingByProperty('skills', this.skills || []),
        //         },
        //         experience_match: {
        //             ...(matchScores?.experience_match || {}),
        //             disciplines: matchingExp(),
        //             experience: {
        //                 senior: seniorExp,
        //                 intermediate: intermediateExp,
        //                 junior: juniorExp,
        //             },
        //         }
        //     }
        // }


        /*
        |--------------------------------------------------------------------------
        | Candidate Proposal
        |--------------------------------------------------------------------------
        */

        hasConfirmedScope = () => {
            return this.job_candidate?.has_confirmed_scope || this.job_candidate?.scope_confirmed_at
        }

        hasConfirmedPayout = () => {
            return this.job_candidate?.has_confirmed_payout
        }

        hasProposalForClient() {
            if (this.isFixedFee()) {
                return !this.declinedPosition() && this.hasConfirmedPayout()
            }
            let hasExistingProposal = (
                this.matchStatusIsInterested() && !this.declinedPosition()
            );
            let teamScopeOutlinedForConsultant = this.statusIsOutlinedScope() && !this.declinedPosition();

            return hasExistingProposal || this.statusIsQuoteConfirmed() || this.statusIsApproved() || teamScopeOutlinedForConsultant
        }

        hasUnseenProposalUpdate() {
            if (!this.job_candidate?.last_viewed_client_byo_position_candidate_proposal_at || !this.job_candidate?.talent_proposal_updated_at) return true
            return TB.moment(this.job_candidate?.last_viewed_client_byo_position_candidate_proposal_at).isBefore(this.job_candidate?.talent_proposal_updated_at)
        }

        hasSubmittedProposal() {
            return !!this.job_candidate?.talent_proposed_at
        }
        isFixedRetainerProposalValid(isRateBased = false) {
            let talentOpp = this.job_candidate?.talent_opps?.[0];

            if(!talentOpp
                || (isRateBased && (!this.job_candidate?.exact_platform_rate || !this.job_candidate?.confirmed_avg_hours_per_period))
                || (!isRateBased && !talentOpp.platform_cost)) {
                false
            }
            return true
        }
        proposedPlatformPayoutPerPeriod(isRateBased = false, formatted = true) {

            let talentOpp = this.job_candidate?.talent_opps?.[0];

            if(!this.isFixedRetainerProposalValid(isRateBased)) {
                return (
                    <i>Pending</i>
                );
            }

            console.log('proposedPlatformPayoutPerPeriod', this.job_candidate?.exact_platform_rate)
            let cost = isRateBased ? (this.job_candidate?.exact_platform_rate * this.job_candidate?.confirmed_avg_hours_per_period) :
                talentOpp.platform_cost;

            if (!formatted) {
                return parseFloat(cost);
            }
            return TB.formatCurrency(parseFloat(cost));
        }

        proposedPlatformCost(formatted = true) {

            if(!this.job_candidate?.exact_platform_cost) {
                return (
                    <i>Pending</i>
                );
            }

            let rate = this.job_candidate?.exact_platform_cost || 0
            if (!formatted) {
                return rate;
            }
            return TB.formatCurrency(rate)
        }

        proposedPlatformRate(formatted = true) {
            if (!this.job_candidate?.platform_rate) {
                return false
            }
            let rate = parseFloat(this.job_candidate?.platform_rate);

            rate = Math.ceil(rate);
            if (!formatted) {
                return rate;
            }
            return TB.formatCurrency(rate, false)
        }

        clientPreferredRate(formatted = true) {

            if (!this.client_override_hourly_rate) {
                return false
            }

            let markupMultiplier = this.markup_multiplier || (1+TB.auth().user()?.clientOrg()?.defaultPercentMarkup());

            let rate = parseFloat(this.client_override_hourly_rate * markupMultiplier);

            if (this.client_override_platform_rate) {
                rate = this.client_override_platform_rate
            }

            rate = Math.ceil(rate);
            if (!formatted) {
                return rate;
            }
            return TB.formatCurrency(rate)
        }

        standardPlatformRate(formatted = true, precise = false) {
            if (this.client_override_hourly_rate) {
                return this.clientPreferredRate(formatted)
            }
            let rate = parseFloat(this.avg_platform_rate);

            if(this.job_candidate && (this.job_candidate?.platform_standard_rate || this.job_candidate?.platform_rate)) {
                rate = parseFloat(this.job_candidate?.platform_standard_rate || 0)
                if (!this.job_candidate?.platform_standard_rate && this.job_candidate?.platform_rate) {
                    rate = parseFloat(this.job_candidate?.platform_rate)
                }
            }

            if (!precise) {
                rate = Math.ceil(rate);
            }

            if (!formatted) {
                return rate;
            }
            return TB.formatCurrency(rate)
        }

        rangedPlatformRates(showCurrencyForRange = false, formatted = true) {
            if (this.client_override_hourly_rate) {
                return this.clientPreferredRate(formatted)
            }
            let minRate = parseFloat(this.min_platform_rate);
            let maxRate = parseFloat(this.max_platform_rate);
            let avgRate = parseFloat(this.avg_platform_rate);
            if (!minRate && !maxRate && !avgRate && this.talent_disciplines?.length) {
                let rates = TB.map(this.talent_disciplines, dis => dis.standard_platform_rate ? parseFloat(dis.standard_platform_rate) : parseFloat(dis.hourly_rate || 0))
                minRate = TB.min(rates);
                maxRate = TB.max(rates);
                avgRate = TB.mean(rates);
            }

            if(maxRate && minRate && maxRate !== minRate) {
                return showCurrencyForRange ? `${TB.formatCurrency(minRate)} - ${TB.formatCurrency(maxRate)}` : `${formatted ? TB.formatCurrency(minRate) : TB.formatNumber(minRate)}-${TB.formatNumber(maxRate)}`
            }else if(!maxRate && minRate) {
                return formatted ? TB.formatCurrency(minRate) : TB.formatNumber(minRate)
            }else if(!minRate && maxRate) {
                return formatted ? TB.formatCurrency(maxRate) : TB.formatNumber(maxRate)
            }
            return formatted ? TB.formatCurrency(avgRate) : TB.formatNumber(avgRate)
        }

        changedHourlyRate() {
            return this.hasSubmittedProposal() &&
                this.proposedPlatformRate(false) &&
                this.proposedPlatformRate(false) !==
                this.standardPlatformRate(false)
        }


        availableStartDate()
        {
            // if (!this.hasSubmittedProposal()) {
            //     return 'Final Confirmation Pending';
            // }

            if (!this.hasProposalForClient() || !this.hasSubmittedProposal()) {
                return 'TBD';
            }

            if (this.confirmedStartedAt()) {
                return this.confirmedStartedAt();
            }

            return 'TBD'
        }

        confirmedStartedAt()
        {
            if (!this.job_candidate?.confirmed_started_at || !TB.moment(this.job_candidate?.confirmed_started_at).isValid()) {
                return false
            }
            if (!this.hasSubmittedProposal()) {
                return 'Final Confirmation Pending';
            }

            return TB.moment(this.job_candidate?.confirmed_started_at).format('MM/DD/YYYY');
        }

        confirmedAvailableHoursPerWeek()
        {
            if (!this.job_candidate?.confirmed_avg_hours_per_period && !parseInt(this.job_candidate?.confirmed_avg_hours_per_period)) {
                return false
            }

            if (!this.hasSubmittedProposal()) {
                return 'Final Confirmation Pending';
            }

            return `Confirmed ${this.job_candidate?.confirmed_avg_hours_per_period} Hours Per Week`;
        }

        unreadMessageCount() {
            return this.job_candidate?.unread_messages_count
        }
        hasRequestedInterview()
        {
            return TB.isDefined(this.job_candidate?.interview_requested_at);
        }

        hasInterviewUpdateSinceLastViewed(lastViewed = this.job_candidate?.last_viewed_client_byo_position_candidate_proposal_at) {

            if(!this.job_candidate?.latest_meeting_update_at) return false;

            if(!lastViewed) return true;

            if(TB.moment(lastViewed).isSameOrBefore(this.job_candidate?.latest_meeting_update_at)) {
                return true
            }

            return TB.moment(lastViewed).diff(this.job_candidate?.latest_meeting_update_at, 'hour', true) <= 1
        }

    }
}

export default IsCandidate